var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnknownIntegration = function SvgUnknownIntegration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 0.5,
    y: 0.5,
    stroke: "#F2F4F7",
    rx: 7.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F2F4F7",
    clipPath: "url(#unknown-integration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.798-29.505 1.13 1.13-85.88 85.88-1.13-1.13zM10.808-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM17.818-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM24.829-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM31.84-29.505l1.13 1.13-85.881 85.88-1.13-1.13zM38.85-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM45.86-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM52.87-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM59.88-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM66.89-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM73.9-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM80.911-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM87.922-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM94.932-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM101.942-29.505l1.13 1.13-85.88 85.88-1.13-1.13zM108.953-29.505l1.13 1.13-85.88 85.88-1.13-1.13z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M20.667 12H7.333m8 5.667L17 16l-1.667-1.667m-2.666 0L11 16l1.667 1.667M7.333 11.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h6.934c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-5.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.147 8 18.587 8 17.467 8h-6.934c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unknown-integration_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#fff",
    rx: 8
  })))));
};
export default SvgUnknownIntegration;